import React, { useEffect, useState } from 'react';
import Navbar from '../components/Navbar/Navbar';
import Hero from '../components/Hero/Hero';
import FeatureCard from '../components/FeatureCard/FeatureCard';
import Services from '../components/Services/Services';
import './Home.css';  
import aboutImg from '../assets/About/About-1.jpg';
import aboutImg2 from '../assets/About/About-2.jpg';
import ProjectSlider from '../components/ProjectSlider/ProjectSlider';
import ReviewCard from '../components/ReviewCard/ReviewCard';
import { Navigation, Autoplay } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import reviewService from '../api/reviewService';
// Also ensure you have the swiper CSS imported if you haven't already
import 'swiper/css';
import 'swiper/css/navigation';
import Footer from '../components/Footer/Footer';
import QuotePopup from '../components/QuotePopup/QuotePopup';
const Home = () => {
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    // Show popup automatically when page loads
    setShowPopup(true);
  }, []);
  // const featureData = [
  //   {
  //     icon: "bi-house-gear",
  //     title: "Quality Workmanship",
  //     desc: "Provide our people with a meaningful experience that helps and guide growth.",
  //     progress: "35%"
  //   },
  //   {
  //     icon: "bi-bricks",
  //     title: "Project Management",
  //     desc: "Provide our people with a meaningful experience that helps and guide growth.",
  //     progress: "45%"
  //   },
  //   {
  //     icon: "bi-patch-check",
  //     title: "Certified Professionals",
  //     desc: "Provide our people with a meaningful experience that helps and guide growth.",
  //     progress: "25%"
  //   }
  // ];
  const featureData = [
  {
    icon: "bi-shield-check", // Updated icon for safety/quality
    title: "Quality Workmanship",
    desc: "We ensure every brick and beam meets the highest industry standards for lasting durability.",
    progress: "50%" // Higher percentages look better for construction reliability
  },
  {
    icon: "bi-building-gear", // Updated icon for management
    title: "Project Management",
    desc: "Expert oversight from groundbreaking to final inspection, ensuring timelines and budgets are met.",
    progress: "50%"
  },
  {
    icon: "bi-patch-check", // Updated icon for professionals
    title: "Certified Professionals",
    desc: "Our team consists of licensed engineers and craftsmen with decades of field experience.",
    progress: "50%"
  }
];
   // 1. State to track the active tab
  const [activeTab, setActiveTab] = useState('Mission');

  // 2. Data object containing content for each tab
 const tabData = {
  Mission: {
    text: "Our mission to build dream spaces with quality, integrity, transparency, and sustainability in concurrence with modernised ideasby utilising BIM technology. We believe that the construction process benefits our clients by having a team with professional approach.",
    points: ["Nation-Building Projects", "Local Resource Optimization"]
  },
  Vision: {
    text: "Our vision to become one of the large-scale industries in infrastructure consultation by leveraging our expertise in construction to bring efficient and impactful transformation.",
    points: ["Smart City Integration", "Make in India Excellence"]
  },
  'Core Value': {
    text: "Our core values like proper communication, right price for right work, commitment, and Integrity.",
    points: ["Zero-Harm Safety Policy", "Quality Assurance Standards"]
  }
};

// const reviews = [
//     { id: 1, name: "Arjun Mehta", company: "Urban Sprawl", rating: 5, review: "VPS delivered our industrial plant 2 months ahead of schedule. Truly professional.", image: "https://i.pravatar.cc/150?u=1" },
//     { id: 2, name: "Sarah Khan", company: "Khan Real Estate", rating: 4, review: "Clean code, beautiful design, and really not hard to work with on complex blueprints.", image: "https://i.pravatar.cc/150?u=2" },
//     { id: 3, name: "Rajesh Iyer", company: "NHAI Partner", rating: 5, review: "The structural integrity of their highway projects is top-notch. Highly recommended.", image: "https://i.pravatar.cc/150?u=3" },
//     { id: 4, name: "Priya Sharma", company: "Tech Hub India", rating: 5, review: "Their attention to safety standards is what sets them apart in the Indian market.", image: "https://i.pravatar.cc/150?u=4" }
//   ];
const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);
 useEffect(() => {
    const fetchPublicReviews = async () => {
      try {
        const data = await reviewService.getAllReview();
        // Filter to show only active reviews
        const activeOnly = Array.isArray(data) 
          ? data.filter(rev => rev.isActive !== false) 
          : [];
        setReviews(activeOnly);
      } catch (error) {
        console.error("Failed to load reviews:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchPublicReviews();
  }, []);
 

  return (
    <div className="home-wrapper">
      <Navbar />
      <main>
        <Hero />
        {showPopup && <QuotePopup onClose={() => setShowPopup(false)} />}
        {/* The Three Card Section */}
        <section className="feature-section py-5 bg-white">
          <div className="container">
            <div className="row g-4">
              {featureData.map((item, index) => (
                <div className="col-lg-4 col-md-6" key={index}>
                  <FeatureCard 
                    icon={item.icon}
                    title={item.title}
                    description={item.desc}
                    progress={item.progress}
                    theme="dark" // Passing a theme prop to apply dark styling
                  />
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* About Section - Matching your expectation */}
        <section className="about-section py-5 bg-white">
          <div className="container">
            <div className="row align-items-center">
              
              {/* Left Column: Large Image with Yellow Logo Overlay */}
              <div className="col-lg-5 mb-5 mb-lg-0">
                <div className="about-image-wrapper position-relative">
                  <img src={aboutImg} alt="VPS Infrastructure Site" className="img-fluid rounded-1" />
                  <div className="about-logo-badge">
                    <i className="bi bi-chevron-double-up"></i>
                  </div>
                </div>
              </div>

              {/* Right Column: Main Content */}
              <div className="col-lg-7 ps-lg-5">
                <span className="about-subtitle text-warning fw-bold mb-2 d-block">
                  ● ABOUT VPS INFRASTRUCTURE
                </span>
                <h2 className="display-5 fw-bold mb-4">
                  Building the Future of Modern Infrastructure
                </h2>
                <p className="text-muted mb-4">
                  Inspired by our grandfather timeless legacy in construction, VPS
Infrastructure was established in 2019 in the heart Dindigul, Tamil
Nadu. While our family has long excelled in government projects, I
chose to channel that expertise into private sector innovation,
delivering tailored solutions that exceed expectations. we specialize in
a wide range of projects across Architecture, Engineering and
Construction (AEC) including residential, commercial, renovations &
Interior Projects. Every project big or small is crafted with unwavering
quality, cutting edge innovation and total commitment to our clients.
                </p>

                {/* Tab Selection */}
                <div className="about-tabs-nav d-flex gap-4 border-bottom mb-4">
                  {Object.keys(tabData).map((tab) => (
                    <button 
                      key={tab}
                      className={`tab-link ${activeTab === tab ? 'active' : ''}`}
                      onClick={() => setActiveTab(tab)}
                    >
                      {tab}
                    </button>
                  ))}
                </div>

                {/* Dynamic Content Row */}
                <div className="row g-4 align-items-start mb-4">
                  <div className="col-md-7">
                    <p className="small text-muted mb-3">
                      {tabData[activeTab].text}
                    </p>
                    <ul className="list-unstyled">
                      {tabData[activeTab].points.map((point, index) => (
                        <li key={index} className="mb-2 fw-bold small">
                          <i className="bi bi-check-lg text-warning me-2"></i> {point}
                        </li>
                      ))}
                    </ul>
                  </div>
                  <div className="col-md-5">
                    {/* Secondary image next to text */}
                    <img src={aboutImg2} alt="Project Progress" className="img-fluid rounded-2 shadow-sm side-small-img" />
                  </div>
                </div>

                {/* Footer Action */}
                <div className="d-flex align-items-center flex-wrap gap-4 mt-5">
                  <button className="btn btn-warning fw-bold px-4 py-3 rounded-1 shadow-sm">
                    Discover More <i className="bi bi-arrow-up-right ms-1"></i>
                  </button>
                  <div className="experience-badge d-flex align-items-center gap-3 ps-4 border-start border-2">
                    <span className="display-4 fw-bold text-dark lh-1">8</span>
                    <span className="small text-uppercase fw-bold lh-sm">
                      Years Of <br/> Experience
                    </span>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </section>

        <Services />
        <ProjectSlider />
        
        <section className="review-section-wrapper py-5 bg-light">
          <div className="container">
            <div className="d-flex justify-content-between align-items-end mb-5">
              <div>
                <span className="text-warning fw-bold small">● CLIENT REVIEWS</span>
                <h2 className="display-6 fw-bold">What Our Partners Say</h2>
              </div>
              {/* Slider Arrows */}
              <div className="d-flex gap-2">
                <button className="rev-prev btn btn-outline-dark rounded-circle"><i className="bi bi-arrow-left"></i></button>
                <button className="rev-next btn btn-warning rounded-circle"><i className="bi bi-arrow-right"></i></button>
              </div>
            </div>

            <Swiper
              modules={[Navigation, Autoplay]}
              spaceBetween={20}
              slidesPerView={1}
              navigation={{ nextEl: '.rev-next', prevEl: '.rev-prev' }}
              breakpoints={{
                768: { slidesPerView: 2 },
                1200: { slidesPerView: 4 }, // 4 Column Row
              }}
            >
              {reviews.map(rev => (
                <SwiperSlide key={rev.id}>
                  <ReviewCard {...rev} />
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </section>
       
        
      </main>
    </div>
  );
};

export default Home;